export type DisplayCurrency = 'RUB' | 'EUR';

const TIMEZONE_KEY = 'lovo.timezone';
const CURRENCY_KEY = 'lovo.display-currency';

export function getRuntimeTimezone() {
  return localStorage.getItem(TIMEZONE_KEY) || 'Europe/Moscow';
}

export function setRuntimeTimezone(value: string) {
  localStorage.setItem(TIMEZONE_KEY, value);
}

export function getDisplayCurrency(): DisplayCurrency {
  return localStorage.getItem(CURRENCY_KEY) === 'EUR' ? 'EUR' : 'RUB';
}

export function setDisplayCurrency(value: string) {
  localStorage.setItem(CURRENCY_KEY, value === 'EUR' ? 'EUR' : 'RUB');
}
